import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
} from '@angular/core';
import { RouterEvent, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import AOS from 'aos';
import { SubSink } from 'subsink';

@Component({
  selector: 'signgaze-footer-container',
  templateUrl: './footer-container.component.html',
  styleUrls: ['./footer-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterContainerComponent implements OnInit, OnDestroy {
  readonly subSink: SubSink = new SubSink();

  isHelpTopicsVisible = true;

  constructor(private router: Router) {}

  ngOnInit(): void {
    AOS.init();
    this.setHelpTopicVisibility();
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  private setHelpTopicVisibility(): void {
    this.subSink.sink = this.router.events
      .pipe(filter((event: RouterEvent) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (
          event.url === '/' ||
          event.url === '/screen-detail' ||
          event.url === '/career' ||
          event.url === '/career/detail' ||
          event.url === '/about' ||
          event.url === '/contact' ||
          event.url === '/privacy' ||
          event.url === '/terms-condition' ||
          event.url === '/screen-detail' ||
          event.url.match('/listing/')?.index === 0
        ) {
          this.isHelpTopicsVisible = true;
        } else {
          this.isHelpTopicsVisible = false;
        }
      });
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }
}
